import React, { FC, useContext, useMemo } from 'react';
import { ListingInfoAside } from '../ListingInfoAside';
import LeadContext from '../../providers/Lead/Lead.context';
import StatementOfInformationCard from '../StatementOfInformationCard';
import {
  checkHasListing,
  checkIsUrgent,
  getAskingPrice,
  mapValueToMoneyFormat,
} from 'utils';
import { ASKING_PRICE_SELECT } from 'models/DealRoom';
import { useTranslation } from 'react-i18next';
import { COMMERCIAL_PROPERTY_TRANSLATION } from '../../../Seller/subrouters/ListingDetailSeller/subrouters/ListingInformation/pages/ListingInformationPage/utils';

type ListingLayoutProps = {
  hideSidePanel?: boolean;
  isBuying: boolean;
};

const ListingLayout: FC<ListingLayoutProps> = ({
  hideSidePanel,
  isBuying,
  children,
}) => {
  const { dealRoom, listing } = useContext(LeadContext);
  const {
    location,
    industry,
    revenue,
    EBITDA,
    averageStockValue,
    locationPostcode,
    type,
    dealLocation,
    askingPriceSelect,
    hasCommercialProperty,
    commercialProperty,
  } = listing || {};

  const isEOI =
    askingPriceSelect === ASKING_PRICE_SELECT.EXPRESSION_OF_INTEREST;
  const showStockValue = (!isEOI || !isBuying) && averageStockValue;

  const askingPrice = useMemo(
    () => getAskingPrice(listing, !isBuying),
    [isBuying, listing],
  );

  const { t } = useTranslation();

  return (
    <>
      {!hideSidePanel && <ListingInfoAside />}
      <main>
        {children}

        {isBuying &&
          checkHasListing(dealRoom?.listingStage) &&
          !checkIsUrgent(type) && (
            <StatementOfInformationCard
              statementOfInformation={{
                amount: `${askingPrice}${
                  showStockValue
                    ? ` + stock (~${mapValueToMoneyFormat(averageStockValue)})`
                    : ''
                }`,
                industry,
                locationPostcode,
                location: location?.state || dealLocation,
                revenue: revenue && `${mapValueToMoneyFormat(revenue)}`,
                EBITDA: EBITDA && `${mapValueToMoneyFormat(EBITDA)}`,
                ...(hasCommercialProperty && {
                  ownersAlsoOwnCommercialProperty: t(
                    COMMERCIAL_PROPERTY_TRANSLATION[commercialProperty],
                  ),
                }),
              }}
            />
          )}
      </main>
    </>
  );
};

export default ListingLayout;
